"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.TIME_OF_DAY = void 0;
exports.default = TimeFilter;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _button = _interopRequireDefault(require("@kyruus/button"));
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
const TIME_OF_DAY = exports.TIME_OF_DAY = {
  ALL: 'ALL',
  AM: 'AM',
  PM: 'PM'
};
const ToggleBtn = _ref => {
  let {
    isSelected,
    mode = 'secondary',
    onClick,
    ...props
  } = _ref;
  return isSelected ? /*#__PURE__*/_react.default.createElement(_styles.SelectedBtn, (0, _extends2.default)({
    mode: mode
  }, props)) : /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    mode: mode,
    onClick: onClick
  }, props));
};
function TimeFilter(_ref2) {
  let {
    filterBy,
    onChange
  } = _ref2;
  let selected = null;
  if (filterBy.timeOfDay.has(TIME_OF_DAY.AM)) selected = TIME_OF_DAY.AM;
  if (filterBy.timeOfDay.has(TIME_OF_DAY.PM)) selected = TIME_OF_DAY.PM;
  if (filterBy.timeOfDay.size === 0) selected = TIME_OF_DAY.ALL;
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "TimeFilter"
  }, /*#__PURE__*/_react.default.createElement(_styles.ButtonGroup, null, /*#__PURE__*/_react.default.createElement(ToggleBtn, {
    isSelected: selected === TIME_OF_DAY.ALL,
    onClick: () => onChange(new _set.default([]), TIME_OF_DAY.ALL)
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default['timeOfDay.all'])), /*#__PURE__*/_react.default.createElement(ToggleBtn, {
    isSelected: selected === TIME_OF_DAY.AM,
    onClick: () => {
      onChange(new _set.default([TIME_OF_DAY.AM]), TIME_OF_DAY.AM);
    }
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default['timeOfDay.am'])), /*#__PURE__*/_react.default.createElement(ToggleBtn, {
    isSelected: selected === TIME_OF_DAY.PM,
    onClick: () => {
      onChange(new _set.default([TIME_OF_DAY.PM]), TIME_OF_DAY.PM);
    }
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default['timeOfDay.pm']))));
}
TimeFilter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TimeFilter"
};